/**
 * ===========================
 * Mobile Drop Down Module
 * ==========================
 */

const mobileDropDown = (function(){
  //config
  const config = (function() {
    const configObj = {
      mobileTab: $('[data-dropdown]')
    };

    return configObj;
  }());

  const bindUIActions = function() {
    $.each(config.mobileTab, function(i) {
      const mobileTabButton = config.mobileTab[i];

      $(mobileTabButton).on('click', function (e) {
        e.preventDefault();
        $(config.mobileTab).not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });
    })
  }

  const init = function() {
    bindUIActions();
  }

  return {
    init: init
  }

}());

//mobileDropDown.init();